import React, { PureComponent } from 'react';

import RainbowInput from '@ott/rainbow-input';
import CloserIcon from '@ott/icon-close';

import { withLayoutContext } from '@ott/layout-context';

import cls from 'classnames/bind';
import s from './MobileHeader.scss';

const cx = cls.bind(s);

@withLayoutContext
class MobileHeader extends PureComponent {
  constructor(props, ctx) {
    super(props, ctx);

    this.setHeaderControlRef = this.setRef.bind(this, 'headerControlRef');

    this.state = { mobileValue: props.value };
  }

  componentDidMount() {
    const { headerControlRef } = this;

    setTimeout(() => {
      if (headerControlRef && headerControlRef.inputRef) {
        headerControlRef.inputRef.focus();
      }
    });
  }

  setRef = (key, element) => {
    this[key] = element;
  };

  handleHeaderInputChange = value => {
    this.props.handleChange(value, false);
  };

  handleClearButtonClick = () => {
    this.props.handleChange('', true);
  };

  renderClearIcon(isVisible) {
    const { isTouchDevice } = this.props;

    return (
      <CloserIcon
        size="normal"
        className={cx('clearIcon', { 'clearIcon--isVisible': isVisible })}
        onClick={isTouchDevice ? undefined : this.handleClearButtonClick}
        onTouchEnd={isTouchDevice ? this.handleClearButtonClick : undefined}
      />
    );
  }

  render() {
    const {
      title,
      additionalInfo,
      overlayAdditionalInfo,
      throbberNode,
      handleCloseButtonClick,
    } = this.props;

    const { isTouchDevice } = this.props;

    const value = this.props.value || '';

    const inputProps = {
      onClick: undefined,
      onKeyDown: this.props.handleKeyDown,
      onMouseDown: this.handleMouseDown,
      onChange: this.handleHeaderInputChange,
      placeholder: this.props.placeholder,
      additionalInfo: additionalInfo,
      overlayAdditionalInfo: overlayAdditionalInfo,
      'data-error-placement': 'top',
      value,
    };

    return (
      <div>
        <div className={cx('header')}>
          <div className={cx('title')}>{title}</div>
          <CloserIcon
            size="large"
            className={cx('closeIcon')}
            onClick={isTouchDevice ? undefined : handleCloseButtonClick}
            onTouchEnd={isTouchDevice ? handleCloseButtonClick : undefined}
          />
        </div>
        <div className={cx('inputWrap')}>
          <RainbowInput
            childrenClassNames={{ input: cx('input') }}
            {...inputProps}
            hasBottomLine={false}
            withBorder={true}
            ref={this.setHeaderControlRef}
            additionalInfoOnly={true}
          />
          {throbberNode}
          {this.renderClearIcon(!!inputProps.value)}
        </div>
      </div>
    );
  }
}

export default MobileHeader;
